define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ticketView.tmpl"),
        InputField = require("ui/input-field/InputField"),
        TextField = require("ui/textarea-field/TextareaField"),
        Button = require("ui/button/Button"),
        CaseCommentView = require("connection-views/ticketTab/extendedList/CaseCommentView"),
        CaseCommentCollection = require("connection-collections/ticketTab/CommentsCollection"),
        CommentModel = require("connection-models/ticketTab/CommentModel"),
        AttachmentsView = require("connection-views/ticketTab/extendedList/TicketAttachmentView"),
        AttachmentUpload = require("connection-views/ticketTab/extendedList/AttachmentUploadInput"),
        AttachmentsCollection = require("connection-collections/ticketTab/AttachmentsCollection"),
        CheckBox = require("ui/checkbox/Checkbox"),
        DropdownMenu = require("ui/dropdown-menu/DropdownMenu"),
        TicketsListView = require("connection-views/ticketTab/TicketsListView"),
        Loader = require("ui/loader/Loader"),
        HtmlSanitizerUtils = require("HtmlSanitizerUtils"),
        TicketView = {};

    var ACTION_MENU_ITEMS = {
        RESOLVED: "resolved",
        CANCEL: "cancelled",
        DUPLICATE: "duplicate",
        UNREPRODUCIBLE: "unreproducible"
    };

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketView = Marionette.ItemView.extend({
            template: template,
            className: 'ticket-view',
            ui: {
                commentsRegion: ".case-comments-region .case-comments-wrapper",
                commentsTextField: ".case-comments-region .case-comments-create",
                attachmentsRegion: ".case-attachments-region .data-container",
                attachmentsUpload: ".case-attachments-region .case-attachments-upload",
                caseRegion: ".case-comments-region .case-comments-wrapper",
                caseSubject: ".case-subject-container .input-container",
                caseDescription: ".case-description-container .input-container",
                accountId: ".case-accountId-container .input-container",
                accountName: ".case-accountName-container .input-container",
                contactName: ".case-contactName-container .input-container",
                contactEmail: ".case-contactEmail-container .input-container",
                contactPhone: ".case-contactPhone-container .input-container",
                status: ".case-status-container .input-container",
                substatus: ".case-substatus-container .input-container",
                priority: ".case-priority-container .input-container",
                creationDate: ".case-creationDate-container .input-container",
                lastUpdateDate: ".case-lastUpdateDate-container .input-container",
                closedDate: ".case-closedDate-container .input-container",
                actionMenuContainer: ".action-menu",
                checkBoxContainer: ".checkbox-container .input-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                loaderContainer: ".loader-container",
                caseReportContent: ".case-status-details",
                caseStatusContent: ".case-report-details",
                caseDetailsContent: ".case-details-container",
                caseDetailsMinifyIcon: ".case-details",
                reportDetailsMinifyIcon: ".status-details",
                statusDetailsMinifyIcon: ".report-details"
            },
            uiComponents: {
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEConnection.cases.detailedView.closeCase.action"),
                        collection: "view._getActionMenuCollection"
                    },
                    events: {
                        "change": "_onActionMenuSelected"
                    }
                },
                commentsTextField: {
                    type: TextField,
                    options: {
                        el: "view.ui.commentsTextField"
                    }
                },
                commentsRegion: {
                    type: CaseCommentView,
                    options: {
                        el: "view.ui.commentsRegion",
                        collection: "view._getCommentsCollection"
                    }
                },
                attachmentsRegion: {
                    type: AttachmentsView,
                    options: {
                        el: "view.ui.attachmentsRegion",
                        collection: "view._getAttachmentsCollection"
                    }
                },
                attachmentsUpload: {
                    type: AttachmentUpload,
                    options: {
                        el: "view.ui.attachmentsUpload",
                        collection: "view._getAttachmentsCollection"
                    }
                },
                caseSubject: {
                    type: InputField,
                    options: {
                        el: "view.ui.caseSubject",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                caseDescription: {
                    type: TextField,
                    options: {
                        el: "view.ui.caseDescription",
                        permutation: InputField.Permutation.B,
                        enabled:false
                    }
                },
                accountId: {
                    type: InputField,
                    options: {
                        el: "view.ui.accountId",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                accountName: {
                    type: InputField,
                    options: {
                        el: "view.ui.accountName",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                contactName: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactName",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                contactEmail: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactEmail",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                contactPhone: {
                    type: InputField,
                    options: {
                        el: "view.ui.contactPhone",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                status: {
                    type: InputField,
                    options: {
                        el: "view.ui.status",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                substatus: {
                    type: InputField,
                    options: {
                        el: "view.ui.substatus",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                priority: {
                    type: InputField,
                    options: {
                        el: "view.ui.priority",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                creationDate: {
                    type: InputField,
                    options: {
                        el: "view.ui.creationDate",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                lastUpdateDate: {
                    type: InputField,
                    options: {
                        el: "view.ui.lastUpdateDate",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },
                closedDate: {
                    type: InputField,
                    options: {
                        el: "view.ui.closedDate",
                        permutation: InputField.Permutation.B,
                        readonly: true,
                        disabled: true
                    }
                },

                checkBoxVisibility: {
                    type: CheckBox,
                    options: {
                        el: "view.ui.checkBoxContainer"
                    }
                },

                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events:{
                      "click":"_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events:{
                        "click":"_onSave"
                    }
                }
            },
            events: {
                "click .status-details": "_onStatusLabelClicked",
                "click .report-details": "_onReportLabelClicked",
                "click .case-details": "_onCaseDetailsLabelClicked"
            },

            initialize: function (options) {
                this.model = options.model;
                this.channel = options.channel;
            },

            onRender: function () {
                this.uiComponents.caseSubject.setValue(this.model.getSummary());
                this.uiComponents.caseDescription.setValue(this.model.getDetails());
                this.uiComponents.accountId.setValue(this.model.getSiteId());
                this.uiComponents.accountName.setValue(this.model.getAccountName());
                this.uiComponents.closedDate.setValue(this.model.getClosedDateConverted());
                this.uiComponents.creationDate.setValue(this.model.getCreatedDateConverted());
                this.uiComponents.lastUpdateDate.setValue(this.model.getLastUpdateDateConverted());
                this.uiComponents.contactName.setValue(this.model.getContactName());
                this.uiComponents.contactEmail.setValue(this.model.getContactEmail());
                this.uiComponents.contactPhone.setValue(this.model.getContactPhone());
                this.uiComponents.priority.setValue(this.model.getPriority());
                this.uiComponents.status.setValue(this.model.getStatus());
                this.uiComponents.substatus.setValue(this.model.getSubStatus());
                this.uiComponents.checkBoxVisibility.setCheckedState(this.model.getVisibility());
                this.uiComponents.caseDescription.ui.textarea.prop("disabled",true);
                this.uiComponents.attachmentsUpload.setDisabled(this.model.isClosed());
                this._setActionMenu();
            },

            closeLoader: function(){
                this._closeLoader();
            },

            setLoader: function(){
                this._setLoader();
            },

            _setActionMenu: function(){
                if(this.model.isClosed()){
                    this.uiComponents.actionMenu.setEnabled(false);
                }
            },

            _getAttachmentsCollection: function () {
                if(!this.attachmentsCollection){
                    this.attachmentsCollection = new AttachmentsCollection(this.model.getAttachments(),{ticketModel:this.model});
                }
                return this.attachmentsCollection;
            },

            _getCommentsCollection: function () {
                return new CaseCommentCollection(this.model.getAllComments(),{ticketModel:this.model});
            },

            _onCancel: function () {
                this.channel.vent.trigger("TicketViewController::window:close");
            },

            _onSave: function () {
                this._collectInformation();
            },

            _collectInformation: function () {
                var message =  HtmlSanitizerUtils.sanitizeHtml(this.uiComponents.commentsTextField.getValue()).cleanText;
                var newComment;
                if(message){
                    newComment = new CommentModel({message:message});
                }
                this._resetCommentTextField();
                var makeVisible = this.uiComponents.checkBoxVisibility.isChecked();
                this.channel.vent.trigger("TicketViewController::ticket:update", {comment:newComment,visibility:makeVisible});
            },

            _resetCommentTextField: function(){
                this.uiComponents.commentsTextField.setValue("");
            },

            //----ACTION MENU
            _getActionMenuCollection: function () {
                var itemsArr = _.map(ACTION_MENU_ITEMS, function (itemId) {
                    return {
                        id: itemId,
                        actionName: LE.translator.translate("LEConnection.cases.detailedView.closeCase.reason." + itemId),
                        align: "left",
                        title: LE.translator.translate("LEConnection.cases.detailedView.closeCase.tooltip")
                    };
                });
                this.actionsCollection = new DropdownMenu.Collection(itemsArr);
                return this.actionsCollection;
            },

            _onActionMenuSet: function (options) {
                var actionItemModel = this.actionsCollection.get(options.id);
                if (!_.isEmpty(actionItemModel)) {
                    actionItemModel.set("enabled", options.enabled);
                }
            },

            _onActionMenuSelected: function (stuff,stufff,selectedItemId) {
                this.channel.vent.trigger("TicketView::actionMenu:selected", selectedItemId);
            },

            _onStatusLabelClicked: function(){
                this.ui.caseReportContent.toggleClass("minimized");
                this.ui.reportDetailsMinifyIcon.toggleClass("show-plus");
            },

            _onReportLabelClicked: function(){
                this.ui.caseStatusContent.toggleClass("minimized");
                this.ui.statusDetailsMinifyIcon.toggleClass("show-plus");
            },

            _onCaseDetailsLabelClicked: function(){
                this.ui.caseDetailsContent.toggleClass("minimized");
                this.ui.caseDetailsMinifyIcon.toggleClass("show-plus");
            },


            //LOADER
            _setLoader:function(){
                this._getLoader().render();
            },

            _closeLoader: function () {
                this._getLoader().close();
            },

            _getLoader:function(){
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.ui.loaderContainer,
                        zIndex:2
                    });
                }
                return this.loader;
            }
        });
    });
    TicketView.ACTION_MENU_ITEMS = ACTION_MENU_ITEMS;
    return TicketView;
});
